/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Car: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M16 20V22C16 22.552 16.448 23 17 23H21C21.552 23 22 22.552 22 22V20H16Z' fill='currentColor' />
    <path
      d='M1 19H23C23.552 19 24 18.552 24 18V12C24 11.735 23.895 11.48 23.707 11.293L21.903 9.489L19.97 1.757C19.859 1.312 19.459 1 19 1H5C4.541 1 4.141 1.312 4.03 1.757L2.097 9.489L0.293 11.293C0.105 11.48 0 11.735 0 12V18C0 18.552 0.448 19 1 19ZM20 14.5C20 15.328 19.328 16 18.5 16C17.672 16 17 15.328 17 14.5C17 13.672 17.672 13 18.5 13C19.328 13 20 13.672 20 14.5ZM5.781 3H18.219L19.719 9H4.281L5.781 3ZM5.5 13C6.328 13 7 13.672 7 14.5C7 15.328 6.328 16 5.5 16C4.672 16 4 15.328 4 14.5C4 13.672 4.672 13 5.5 13Z'
      fill='currentColor'
    />
    <path d='M2 20V22C2 22.552 2.448 23 3 23H7C7.552 23 8 22.552 8 22V20H2Z' fill='currentColor' />
  </React.Fragment>
)
